import React from "react";

export const SetupPasswordContainerContext = React.createContext();